import React, { useState } from "react";
import {
  IStorage,
  IStorageConfirmBody,
  IStoragePrice,
} from "../../shared/interfaces/storage";
import "./EmailStep.css";
import { Constants } from "../../shared/utils/constants";
import { locationService } from "../../services/location.service";
import { tS } from "../../services/translation.service";

interface IProps {
  onNextStep: () => void;
  storagePrice: IStoragePrice | undefined;
  selectedStorage: IStorage | undefined;
  startDate: Date;
  locationCode: string;
  isBlindFlow: boolean;
  isGerman: boolean;
  selectedLanguage: number;
}

export const EmailStep = (props: IProps) => {
  const { onNextStep, storagePrice, startDate, selectedStorage, isBlindFlow, isGerman, selectedLanguage } =
    props;
  const [email, setEmail] = useState("");
  const [validate, setValidate] = useState(false);
  const isEmailValid =
    !!email && Constants.RegularExpressions.Email.test(email);

  const onValidateEmail = async () => {
    if (!isEmailValid) {
      setValidate(true);
      // TODO: show error message not valid email
      return;
    }

    confirmStorage(email);
  };

  function formatLocalDate(date: Date) {
    const pad = (n: number) => String(n).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

  const confirmStorage = (email: string) => {
    if (
      !selectedStorage?.deliveryCode ||
      !storagePrice?.selectedHours ||
      !storagePrice?.calculatedPrice
    ) {
      // showing error not avalable
      return;
    }

    const localStartDate = formatLocalDate(startDate);

    const getLanguage = (languageValue: number) => {
    if(languageValue === 0) {
      return 'de';
    }else if(languageValue == 1) {
      return 'en';
    } else if(languageValue == 2) {
      return 'sk';
    } else {
      return 'de';
    }
  }

    const bodyRequest: IStorageConfirmBody = {
      deliveryCode: selectedStorage?.deliveryCode,
      email: email,
      startDate: localStartDate,
      selectedHours: storagePrice?.selectedHours,
      calculatedPrice: storagePrice?.calculatedPrice,
      redirectURL: `${process.env.REACT_APP_MOLLIE_REDIRECT}/info-email` + '/' + getLanguage(selectedLanguage),
      blind: isBlindFlow,
    };

    locationService
      .confirmStorage(bodyRequest)
      .then((response) => {
        if (response) {
          if (response.success) {
            window.open(response.webhookURL, "_self");
            onNextStep();
          } else {
            //error creating webhook
          }
        }
      })
      .catch((err) => {
        // showing error creating storage
      });
  };

  const handleChange = (event: any) => {
    setEmail(event.target.value);
  };

  return (
    <div className="container">
      <p>
        {tS.gT(tS.P.PleaseEnterEmail, selectedLanguage)}
      </p>
      <p>
        {tS.gT(tS.P.AftrSuccessfullyCreatingReserervation, selectedLanguage)}
        <br />
        {tS.gT(tS.P.EmailWithCode, selectedLanguage)}
      </p>
      <p>
        {tS.gT(tS.P.AfterPlacingParcelYouReceive, selectedLanguage)}
        <br />
        {tS.gT(tS.P.EmailWithPickUpCode, selectedLanguage)}
      </p>
      <input
        style={{ width: "95%", marginTop: 10 }}
        className={validate && !isEmailValid ? "error-input" : ""}
        autoCapitalize="none"
        placeholder={tS.gT(tS.P.YourEmailAddress, selectedLanguage)}
        value={email}
        onChange={handleChange}
      />
      {validate && !isEmailValid && (
        <p style={{ color: "red" }}>{tS.gT(tS.P.PleaseEnterYourEmail, selectedLanguage)}</p>
      )}
      <button style={{ marginTop: 10 }} onClick={onValidateEmail}>
        {tS.gT(tS.P.Confirm, selectedLanguage)}
      </button>
    </div>
  );
};
